<template>
  <a-layout-sider class="sider-bar-content" :collapsed-width="0">
    <a-menu
      mode="inline"
      :selectedKeys="[activeMenu]"
      :openKeys="openKeys"
      @select="handleMenuSelect"
    >
      <a-menu-item key="/">
        <HomeOutlined />
        <span>首页</span>
      </a-menu-item>
      <template v-for="route in routes">
        <a-sub-menu v-if="route.children.length > 0" :key="route.path">
          <template #title>
            <span>
              <component :is="route.icon"></component>
              <span>{{ route.meta.title }}</span>
            </span>
            <a-icon type="setting"></a-icon>
          </template>
          <SubMenu :menus="route.children" :basePath="route.path" />
        </a-sub-menu>
        <template v-else>
          <a-menu-item :key="route.path" :icon="route.meta.icon">
            
            {{ route.meta.title }}
          </a-menu-item>
        </template>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script setup>
import SubMenu from "./SubMenu.vue";
import { HomeOutlined } from "@ant-design/icons-vue";
import { useRoute, useRouter } from "vue-router";
import { openTab } from "../../utils/tabStore";
import { ref, watch,h } from "vue";
import store from "@/store";

const route = useRoute();
const router = useRouter();
// console.log(router.options.routes)
// const routes = router.options.routes.filter((route) => route.path!='/'&&route.path!='/login');
const routes = store.state.menus
console.log(route);
const activeMenu = ref(route.path);
const openKeys = ref([]);
const handleMenuSelect = ({ key }) => {
  console.log(key);
  const targetRoute = router.getRoutes().find((route) => route.path === key);
  console.log(targetRoute);
  if (targetRoute) {
    router.push({ path: key });
    openTab(targetRoute);
  }
};

watch(
  () => route.path,
  (newPath) => {
    activeMenu.value = newPath;
  }
);
</script>

<style lang="less" scoped>
// .sidebar {
//     position: fixed;
//     top: 64px;
//     left: 0;
//     bottom: 0;
//     width: 200px;
//     z-index: 99;
// }
</style>../../utils/tabStore